// extracted by mini-css-extract-plugin
export default {"container":"VideoMainForm_container__lga3n","flexContainer":"VideoMainForm_flexContainer__U09ET"};